import { memo } from "react";
import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { useAppSelector } from "redux-share";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";
import MarkersList from "../../../player-components/markersList/markersList";
import Settings from "../../../player-components/settings/settings";
import Speed from "../../../player-components/speed/speed";
import Subtitles from "../../../player-components/subtitles/subtitles";

const FullScreen = dynamic(() => import("../../../player-components/fullScreen/fullScreen"));
const PlayList = dynamic(() => import("../../../player-components/playList/playList"));
const AutoPlayToggle = dynamic(() => import("../../../player-components/toggle/autoPlayToggle"));
const PictureInPicture = dynamic(() => import("../../../player-components/pictureInPicture/pictureInPicture"));
const Unlock = dynamic(() => import("../../../player-components/lockUnlock/unlock"));
const MultiLive = dynamic(() => import("../../../player-components/multiLive/multiLive"));
const ElapsedTime = dynamic(() => import("../../../player-components/elapsedTime/elapsedTime"));
const LikeDisLike = dynamic(() => import("../../../player-components/likeDisLike/likeDisLike"));
const SoundVolume = dynamic(() => import("../../../player-components/soundVolume/soundVolume"));
const PlayNextVideo = dynamic(() => import("../../../player-components/playNext/playNextVideo"));
const PlayPauseControllbar = dynamic(() => import("../../../player-components/playPauseControllbar/playPauseControllbar"));

const Controlbar = () => {

    useAppSelector(({ controller: { isFullScreen, showMiniPlayer } }) => ({ isFullScreen, showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params, isComplexPortrait } }) => ({ videoElementSizeInfo, params, isComplexPortrait }), shallowEqual);
  
    return (
        <div id="player-controllbar" className={`pl-flex pl-justify-between pl-items-center pl-m-3`}>
            <div className={`pl-flex pl-items-center ${(conditions(ConditionName.isTouchScreenPortrait) || conditions(ConditionName.isMiniPlayer)) ? "pl-gap-2" : "pl-gap-6"}`}>
                {!conditions(ConditionName.showMiniPlayer) && <FullScreen />}
                {conditions(ConditionName.showSettingIcon) && <Settings />}
                {conditions(ConditionName.showSpeedIcon) && <Speed />}
                {conditions(ConditionName.showPlayListIcon) && <PlayList />}
                {conditions(ConditionName.showAutoPlayToggleIcon) && <AutoPlayToggle />}
                {conditions(ConditionName.showPictureInPicture) && <PictureInPicture />}
                {(!conditions(ConditionName.isStaticFormat) && !conditions(ConditionName.isGeneral)) && <Unlock inControllbar={true}/>}
                {conditions(ConditionName.showMultiLive) && <MultiLive />}
                {conditions(ConditionName.hasSubtitle) && <Subtitles />}
            </div>
            <div className={`pl-flex pl-items-center ${(conditions(ConditionName.isTouchScreenPortrait) || conditions(ConditionName.isMiniPlayer)) ? "pl-gap-2" : "pl-gap-6"}`}>
                {(conditions(ConditionName.showElapsedTime) && !conditions(ConditionName.isMiniPlayer)) && <ElapsedTime />}
                {conditions(ConditionName.showLikeDislike) && <LikeDisLike />}
                {!conditions(ConditionName.isIOS) && <SoundVolume />}
                {conditions(ConditionName.hasMarkers) && <MarkersList />}
                {conditions(ConditionName.showPlayNextIcon) && <PlayNextVideo />}
                {conditions(ConditionName.showReplayIcon) && <PlayPauseControllbar />}
            </div>
        </div>
    )
}

export default memo(Controlbar);